const TURN_LABEL = /^[ \t>*_]*(?:(?:user|human|assistant)\b|(?:User|Human|Assistant)[ \t]*:)/m;

export type CutText = { text: string; fabricated: boolean };

export const cutAtFabricatedTurn = (text: string): CutText => {
  const match = TURN_LABEL.exec(text);
  if (!match) return { text, fabricated: false };
  return { text: text.slice(0, match.index).trimEnd(), fabricated: true };
};
